<script setup lang="ts">
import { type HTMLAttributes, computed } from "vue";
import { cn } from "@/lib/utils";

// Shared URL input shell (replaces the legacy ds-dash .url-box): icon + input (default
// slot) + action button (action slot). Pass class to tweak padding/max-width.
const props = defineProps<{ class?: HTMLAttributes["class"] }>();

const classes = computed(() =>
  cn(
    "flex w-full items-center gap-2 rounded-md border border-input bg-card p-2.5 ps-[18px] shadow-sm transition-[border-color,box-shadow] focus-within:border-primary focus-within:ring-4 focus-within:ring-primary/30",
    props.class,
  ),
);
</script>

<template>
  <div :class="classes">
    <span class="grid flex-none place-items-center text-subtle-foreground" aria-hidden="true">
      <slot name="icon">
        <Icon name="lucide:link" class="h-5 w-5" />
      </slot>
    </span>
    <slot />
    <slot name="action" />
  </div>
</template>
